import * as Immutable from 'immutable';
import { initialDataFields } from './InitialData';
import * as Fields from '../../components/Account/Data/Fields';
import { BaseAccountWizardStore } from './AccountWizardReducer.types';
import { isFinanceStageVisible } from './AccountWizardSelector';

export const initialAccountDataFieldValues = Object.entries(initialDataFields).reduce((acc, [key, value]) => {
  acc[key] = value.value;
  return acc;
}, {} as { [key: string]: any });

export const AGREEMENTS_FORM_STAGES = {
  ReadAgreement: 'ReadAgreement',
  SubmitAgreement: 'SubmitAgreement',
};

export const initialAccountWizardData = Immutable.fromJS({
  dataFields: initialAccountDataFieldValues,
  stage: 0,
  submittedStages: {},
  stageForm: null,
  errors: {},
  isInitialized: false,
  errorPopup: null,
  agreementsFormStage: AGREEMENTS_FORM_STAGES.ReadAgreement,
  isReadAgreements: false,
  protoUsersList: [],
} as BaseAccountWizardStore);

export const FormStagesKeys = {
  EntranceDataStage: 'EntranceDataStage',
  PersonalDataStage: 'PersonalDataStage',
  OccupationStage: 'OccupationStage',
  FinanceStage: 'FinanceStage',
};

export const StagesConfig: WizardFormStage[] = [
  {
    tab: { title: 'Email', description: 'Credentials' },
    name: FormStagesKeys.EntranceDataStage,
    shouldDisplay: () => true,
  },
  {
    tab: { title: 'Name', description: 'Personal data' },
    name: FormStagesKeys.PersonalDataStage,

    shouldDisplay: () => true,
  },
  {
    tab: { title: 'Education', description: 'And employment' },
    name: FormStagesKeys.OccupationStage,

    shouldDisplay: () => true,
  },
  {
    tab: { title: 'Finance', description: 'And trading' },
    name: FormStagesKeys.FinanceStage,

    shouldDisplay: formContext => isFinanceStageVisible(formContext.dataFields),
    optional: true,
  },
];

type StageTab = {
  title: string;
  description: string;
};

export type WizardFormStage = {
  tab: StageTab;
  name: string;
  shouldDisplay: (formContext?: any) => boolean;
  optional?: boolean;
};

export const exposureFieldDeps = [
  Fields.investmentAdvisory.props.name,
  Fields.brokerage.props.name,
  Fields.fundamentalResearch.props.name,
  Fields.proprietaryTrading.props.name,
  Fields.serviceEngagement.props.name,
];
